import { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../../auth/hooks/useAuth";

const useClassSettings = params => {
  const [settings, setSettings] = useState();
  const [status, setStatus] = useState();
  const { state: authState } = useAuth();

  useEffect(() => {
    try {
      (async () => {
        setStatus("LOADING");
        console.log(process.env.REACT_APP_API);
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API}/classroomsettings`,
          params,
          headers: {
            Authorization: `Bearer ${authState.access_token}`
          }
        });
        console.log(response.data)
        setSettings(response.data);
        if(settings !== undefined)
        {
        console.log(settings);
        }
        setStatus("OK");
      })();
    } catch (e) {
      setStatus("ERROR");
      console.log("error")
    }
  }, []);
  console.log(settings);
    return {
      settings,
      status
    };
};

export default useClassSettings;
